// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__xyLKu","actions":"GroupTable_actions__3t0tQ","deleteModalFooter":"GroupTable_deleteModalFooter__9BFUV"};